module.exports = __webpack_public_path__ + "assets/img/kv-f36867d4.jpg";